module.exports = __webpack_public_path__ + "img/21_51.81c394be.png";